export function abbreviateNumber(value: number): string {
    if(value) {
        if (value < 1000) {
            return value.toString(); // If number less than 1000, return as is
        }

        // For numbers between 1000 and 9999, format with a comma
        if (value >= 1000 && value < 10000) {
            return value.toLocaleString();
        }

        if (value >= 10000 && value < 1000000) {
            const abbreviated = value / 1000;
            return formatNumber(abbreviated) + 'k';
        }

        if (value >= 1000000) {
            const abbreviated = value / 1000000;
            return formatNumber(abbreviated, 2) + 'M';
        }

        return value.toString();
    }
    return '0';
}

function formatNumber(value: number, decimalPlaces: number = 4): string {
    let formatted = value.toFixed(decimalPlaces);
    const decimalPart = formatted.split('.')[1];

    if (decimalPart) {
        const lastDigit = parseInt(decimalPart[decimalPart.length - 1], 10);
        let roundedValue = parseFloat(formatted);

        if (lastDigit < 5) {
            roundedValue = Math.floor(roundedValue * 10) / 10;
            formatted = roundedValue.toFixed(1);
        } else if (lastDigit > 5) {
            roundedValue = Math.ceil(roundedValue * 10) / 10;
            formatted = roundedValue.toFixed(1);
        } else if (lastDigit === 5) {
            formatted = roundedValue.toFixed(2);
        }
    }

    return formatted;
}
